@if(currentItem(); as entity)
{       
    <div [ngClass]="{
            'primary-text-100 fw-normal' : isSelectable() && entity.isChecked()
         }">  

        <div class="row gx-0" placement="bottom left" delay="1000" [tooltip]="entity.name()">
            @if(isSelectable()){

                <div class="col-auto d-flex align-items-center">


                    @if(entity.isChecked())
                    {
                        <span class="material-icons-sharp primary-text-100 me-1">check_circle</span>
                    }
                    @else
                    {
                        <span class="material-icons-sharp primary-text-100 me-1">radio_button_unchecked</span>
                    }
                    
                </div>
            }            
        
                            
            <div class="col text-truncate" >                    
                @if(template(); as outputTemplate)
                {
                    <ng-container [ngTemplateOutlet]="outputTemplate" 
                                [ngTemplateOutletContext]="{ $implicit: entity, item: entity }" />                            
                }
                @else
                {
                    <span>{{entity.name()}}</span>
                }
            </div>

        </div>
    </div>
}